import type { ReactNode } from 'react';
import { Dialog, DialogContent } from './dialog';

export interface AppModalProps {
  open?: boolean;
  onClose: () => void;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  ariaLabel?: string;
  testId?: string;
  dismissible?: boolean;
}

/**
 * Modal estándar de la app (UI-STD-1) sobre las primitivas responsive de
 * `shared` (ADR-114). Mantiene el contenido existente (header/body propios)
 * pero aporta overlay, foco, ESC/backdrop, bottom-sheet móvil y scroll-lock.
 */
export function AppModal({
  open = true,
  onClose,
  children,
  size = 'lg',
  ariaLabel,
  testId,
  dismissible = true,
}: AppModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <DialogContent
        size={size}
        ariaLabel={ariaLabel}
        showClose={false}
        dismissible={dismissible}
        data-testid={testId}
        className="border-0 bg-transparent p-0 shadow-none"
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
